import { TabNavigation } from './components/TabNavigation'
import { Outlet } from 'react-router-dom'

function App() {
  return (
    <div className="max-w-[1600px] mx-auto md:p-8 w-full pb-20 md:pb-8 sm:p-0">
      <TabNavigation />

      <Outlet />
    </div>
  )
}

export default App
